var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_4346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 98C76.5097 98 98 76.5097 98 50C98 23.4903 76.5097 2 50 2C23.4903 2 2 23.4903 2 50C2 76.5097 23.4903 98 50 98Z",
    fill: "#C4C4C4",
    stroke: "#34D100",
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_4346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 1C77.0619 1 99 22.938 99 50C99 77.062 77.062 99 50 99C22.938 99 1 77.062 1 50C1 22.938 22.9381 1 50 1Z",
    fill: "#F3F3F3",
    stroke: "#DB1538",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6875 27.7573C49.0483 27.1324 49.9165 27.0935 50.3408 27.6401L50.4199 27.7573L74.208 68.9595C74.5925 69.6261 74.1114 70.4594 73.3418 70.4595H25.7656C25.044 70.4593 24.5761 69.7263 24.8379 69.0854L24.9004 68.9595L48.6875 27.7573Z",
    fill: "#F3F3F3",
    stroke: "#DB1538",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.125 38.5537L51.6562 58.6123H47.6328L47.1445 38.5537H52.125ZM47.0078 64.7646C47.0078 64.0485 47.2422 63.4495 47.7109 62.9678C48.1927 62.473 48.8568 62.2256 49.7031 62.2256C50.5365 62.2256 51.194 62.473 51.6758 62.9678C52.1576 63.4495 52.3984 64.0485 52.3984 64.7646C52.3984 65.4548 52.1576 66.0472 51.6758 66.542C51.194 67.0238 50.5365 67.2646 49.7031 67.2646C48.8568 67.2646 48.1927 67.0238 47.7109 66.542C47.2422 66.0472 47.0078 65.4548 47.0078 64.7646Z",
    fill: "#171717"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0139 26.6606C89.8237 26.6606 95.3441 21.1401 95.3441 14.3303C95.3441 7.52045 89.8237 2 83.0139 2C76.204 2 70.6836 7.52045 70.6836 14.3303C70.6836 21.1401 76.204 26.6606 83.0139 26.6606Z",
    fill: "#DB1538",
    stroke: "#DB1538",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0938 9.41211L87.9755 19.2938",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9755 9.41211L78.0938 19.2938",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR4);
export default __webpack_public_path__ + "static/media/r4.1878778d1efa90633c0e2d587ea4f6af.svg";
export { ForwardRef as ReactComponent };